// removed by extract-text-webpack-plugin
module.exports = {"root":"_1leyhz6","savePrompt":"_1Phuwr5","saveDescription":"_1Vtc7bk"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/SavePanel/components/SaveSearch/SaveSearchWrapper.less
 ** module id = 876
 ** module chunks = 0
 **/